import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ProcessJob, ImportJob, ProcessesState } from '@/types/log.types';

const initialState: ProcessesState = {
  aiJobs: { list: [], totalCount: 0, loading: false },
  importJobs: { list: [], totalCount: 0, loading: false },
  error: null,
};

const processesSlice = createSlice({
  name: 'processes',
  initialState,
  reducers: {
    fetchAiJobsRequest(state, _action: PayloadAction<{ page: number; limit: number; search?: string; status?: string }>) {
      state.aiJobs.loading = true; state.error = null;
    },
    fetchAiJobsSuccess(state, action: PayloadAction<{ list: ProcessJob[]; totalCount: number }>) {
      state.aiJobs = { ...action.payload, loading: false };
    },
    fetchAiJobsFailure(state, action: PayloadAction<string>) {
      state.aiJobs.loading = false; state.error = action.payload;
    },

    searchAiJobsRequest(state, _action: PayloadAction<{ search: string }>) {
      state.aiJobs.loading = true;
    },
    searchAiJobsSuccess(state, action: PayloadAction<{ list: ProcessJob[]; totalCount: number }>) {
      state.aiJobs = { ...action.payload, loading: false };
    },
    searchAiJobsFailure(state, action: PayloadAction<string>) {
      state.aiJobs.loading = false; state.error = action.payload;
    },

    fetchImportJobsRequest(state, _action: PayloadAction<{ page: number; limit: number; search?: string; status?: string }>) {
      state.importJobs.loading = true; state.error = null;
    },
    fetchImportJobsSuccess(state, action: PayloadAction<{ list: ImportJob[]; totalCount: number }>) {
      state.importJobs = { ...action.payload, loading: false };
    },
    fetchImportJobsFailure(state, action: PayloadAction<string>) {
      state.importJobs.loading = false; state.error = action.payload;
    },

    searchImportJobsRequest(state, _action: PayloadAction<{ search: string }>) {
      state.importJobs.loading = true;
    },
    searchImportJobsSuccess(state, action: PayloadAction<{ list: ImportJob[]; totalCount: number }>) {
      state.importJobs = { ...action.payload, loading: false };
    },
    searchImportJobsFailure(state, action: PayloadAction<string>) {
      state.importJobs.loading = false; state.error = action.payload;
    },
  },
});

export const {
  fetchAiJobsRequest, fetchAiJobsSuccess, fetchAiJobsFailure,
  searchAiJobsRequest, searchAiJobsSuccess, searchAiJobsFailure,
  fetchImportJobsRequest, fetchImportJobsSuccess, fetchImportJobsFailure,
  searchImportJobsRequest, searchImportJobsSuccess, searchImportJobsFailure,
} = processesSlice.actions;
export default processesSlice.reducer;
